import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import QuizFunnel from "@/components/QuizFunnel";

function App() {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="App font-body grain" data-testid="app-root">
      <Toaster theme="dark" position="top-center" richColors />
      <QuizFunnel />
    </div>
  );
}

export default App;
